import { UserCancellationInterceptOutcomeInterface } from "@vendor-app/domain/UserCancellationInterceptOutcomeInterface";

import { UserCancellationInterceptOutcomesMapperInterface } from "./interface";

export class UserCancellationInterceptOutcomesMapper implements UserCancellationInterceptOutcomesMapperInterface {
  public mapData(data: any[]): UserCancellationInterceptOutcomeInterface[] {
    const outcomes = data.map(
      mappedOutcome =>
        ({
          id: mappedOutcome.id,
          customerRelationship: mappedOutcome.customerRelationship,
          subscription: mappedOutcome.subscription,
          createdDate: mappedOutcome.createdDate,
          outcome: mappedOutcome.outcome,
        }) as UserCancellationInterceptOutcomeInterface
    );

    return outcomes;
  }
}
